export const getAirportLabel = (
  iata: string | null = null,
  icao: string | null = null,
  fallback = '---',
) => iata ?? icao ?? fallback;
